module.exports = __webpack_public_path__ + "img/boky_08_modra.c8180c06.png";